const projectsData = [
  {
    title: "TBC Bank — Currency Exchange Automation Framework",
    period: "Oct 2025 - Nov 2025",
    description:
      "End-to-end automation framework for TBC Bank currency-exchange and loan calculator workflows — UI tests (Playwright), API validation (RestAssured), performance tests (k6), and CI/CD in Azure DevOps with Allure reporting.",
    tags: ["Playwright", "RestAssured", "k6", "Azure DevOps"],
    githubUrl: null,
    liveUrl: null,
    source: "linkedin",
  },
  {
    title: "EcoFit — Sustainable Smart Fashion Advisor",
    period: "Oct 2025",
    description:
      "AI + VR platform that builds a personalized digital avatar for immersive virtual try-on, surfaces eco-certified brands, and reduces returns.",
    tags: ["AI", "VR", "Hackathon"],
    githubUrl: null,
    liveUrl: null,
    source: "linkedin",
  },
  {
    title: "Runimal — Gamified Social Fitness",
    period: "Oct 2025",
    description:
      "Cross-platform fitness app blending Strava-style activity tracking with location-based creature collection, character customization, and leaderboards.",
    tags: ["Mobile", "GPS", "Gamification"],
    githubUrl: null,
    liveUrl: null,
    source: "linkedin",
  },
  {
    title: "Personal Art Portfolio Website",
    period: "Nov 2025 - Dec 2025",
    description:
      "Responsive gallery-style portfolio to showcase artwork with high-resolution viewing and mobile optimization.",
    tags: ["TypeScript", "React"],
    githubUrl: "https://github.com/DavitEgoian/art-portfolio",
    liveUrl: "https://dedgrl.me/",
    source: "linkedin",
  },
  {
    title: "Dynamic AI & Data Science Portfolio Website",
    period: "May 2025 - Jul 2025",
    description:
      "Personal portfolio built in React with custom variable-font animations, spotlight cards, and an infinite-loop tech stack carousel.",
    tags: ["React", "JavaScript", "Splide"],
    githubUrl: "https://github.com/DavitEgoian/Portfolio-Website",
    liveUrl: "https://davit-egoian.tech",
    source: "linkedin",
  },
  {
    title: "DeepFace Vision",
    period: "GitHub",
    description:
      "Computer vision project powered by DeepFace for recognition of age, gender, and emotion from images.",
    tags: ["Python", "DeepFace", "Computer Vision"],
    githubUrl: "https://github.com/DavitEgoian/deepface-vision",
    liveUrl: null,
    source: "github",
  },
  {
    title: "Image Watermarking Desktop App",
    period: "GitHub",
    description:
      "Python desktop app for batch-processing images with custom text or logo watermarks, smart resizing, and opacity controls.",
    tags: ["Python", "Desktop", "Pillow"],
    githubUrl: "https://github.com/DavitEgoian/image-watermarking-desktop-app",
    liveUrl: null,
    source: "github",
  },
  {
    title: "CryptoRonin",
    period: "GitHub",
    description:
      "Crypto and NFT-themed landing page with responsive visual design built using HTML and CSS.",
    tags: ["HTML", "CSS", "Web Design"],
    githubUrl: "https://github.com/DavitEgoian/CryptoRonin",
    liveUrl: "https://davitegoian.github.io/CryptoRonin/",
    source: "github",
  },
  {
    title: "NYC Public School SAT Score Analysis",
    period: "GitHub",
    description:
      "Jupyter analysis of SAT score trends for NYC public schools, identifying high-performing institutions and borough-specific patterns.",
    tags: ["Jupyter", "Pandas", "Data Science"],
    githubUrl:
      "https://github.com/DavitEgoian/exploring-nyc-public-school-test-result-scores",
    liveUrl: null,
    source: "github",
  },
  {
    title: "UNI4VERSE",
    period: "Sep 2024 - Nov 2024",
    description:
      "Inter-university competition empowering students to design green-economy solutions through research, campus qualifiers, and Tech Park residency mentoring.",
    tags: ["Innovation", "Sustainability", "Competition"],
    githubUrl: null,
    liveUrl: null,
    source: "linkedin",
  },
];

export default projectsData;
